import { useContext, useEffect } from "react"
import ModelElements from "../ModelElements"
import { ProductModelProps } from "../ModelViewerProduct"
import ProductTextureContext from "../_contexts/ProductTextureContext"
import useGLB from "../_hooks/useGLB"
import { FindMaterial } from "../../Common/Utils/ThreeTools"
import { MeshStandardMaterial, Vector2 } from "three"

export default function DrawstringBag(props: ProductModelProps) {
    const url = new URL('@resources/3d-models/glb/drawstring-bag.glb', import.meta.url);
    const model = useGLB(url)
    const elements = model.scene.children
    const [productTexture, fxTexture] = useContext(ProductTextureContext)

    // Adjust normals
    useEffect(() => {
        if(!elements) return
        let mat: MeshStandardMaterial | null

        mat = FindMaterial('fabric', elements)
        if (mat) { mat.normalScale = new Vector2(16.0, -16.0)}
        
        mat = FindMaterial('rope', elements)
        if (mat) { mat.normalScale = new Vector2(4.0, -4.0)}
        
        mat = FindMaterial('detail', elements)
        if (mat) { mat.normalScale = new Vector2(4.0, -4.0)}
    }, [elements])

    // Apply lab texture
    useEffect(() => {
        let mat = FindMaterial('design', elements)
        if(mat && fxTexture) {
            mat.map = fxTexture
            mat.map.flipY = false
            mat.map.needsUpdate = true
        }
    }, [fxTexture, elements])
    
    return <ModelElements scene={model.scene}/>
}